import { render } from "./SupplierView.vue?vue&type=template&id=1a454eb8"
import script from "./SupplierView.vue?vue&type=script&lang=js"
export * from "./SupplierView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__